import ReactDOM from 'react-dom/client';
import { Styles } from "./styles/styles";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import ScrollToTop from './common/ScrollToTop';

import { I18nextProvider } from "react-i18next";
import { LanguageContextProvider } from "./store/language-context";

import Header from "./components/Header";
import Footer from "./components/Footer/Footer";
import Home from './pages/Home/Home';
import HomeMobile from 'pages/Home/MobileView/HomeMobile';
import Point from './pages/Point/Point';
import Point_collection from './pages/Point/Point_collection';
import Museums from './pages/Museums/Museums';
import Collection from './pages/Collection/Collection';
import Events from './pages/Events/Events';
import SingleEvent from './pages/SingleEvent/SingleEvent';
import Cookies from "./components/Cookies/Cookies";
import PolicyPage from './pages/PolicyPage/PolicyPage';
import TermsPage from './pages/TermsPage/TermsPage';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import i18n from 'translation';
import { useEffect, useState } from 'react';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Pol from 'pages/PolicyPage/Pol';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    }
  }
});

const App = () => {
  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    //Handle Responsiveness  
    const handleResize = () => {
      setWidth(window.innerWidth)
    }

    handleResize()

    // Bind the event listener
    window.addEventListener('resize', handleResize)

    return () => {
      // Unbind the event listener on clean up
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <LanguageContextProvider>
              <Cookies />
              <Styles />
              <ScrollToTop />
              <HeaderWithLocation />
              <Routes>
                <Route
                  path="/"
                  element={width > 1200 ? <Home /> : <HomeMobile />  }
                />
                <Route path="museums" element={<Museums />} />
                <Route path="museums/:id" element={<Point />} />
                <Route path="collection" element={<Collection />} />
                <Route path="collection/:id" element={<Point_collection />} />
                <Route path="events" element={<Events />} />
                <Route path="events/:id" element={<SingleEvent />} />
                <Route path="privacy-policy" element={<Pol />} />
                <Route path="terms" element={<TermsPage />} />
              </Routes>
              <FooterWithLocation />
          </LanguageContextProvider>
        </BrowserRouter>
      </I18nextProvider>
    </QueryClientProvider>
  );
};

const HeaderWithLocation = () => {
  const location = useLocation();
  const isNotHomePage = location.pathname !== '/';

  return isNotHomePage ? <Header /> : null;
  // return <Header />
};
const FooterWithLocation = () => {
  const location = useLocation();
  const isNotHomePage = location.pathname !== '/';

  return isNotHomePage ? <Footer /> : null;
  // return <Footer />
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<App />);